import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConsultaFuncionarioDTO } from 'src/app/models/consulta-funcionario.model';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-busqueda-funcionario',
  templateUrl: './busqueda-funcionario.component.html',
  styleUrls: ['./busqueda-funcionario.component.scss']
})
export class BusquedaFuncionarioComponent implements OnInit {

  filtroNombre: string;
  urlFTP: string;
  rolUsuario: string;
  filtroFecha: string;
  listaFuncionarios: ConsultaFuncionarioDTO[];


  constructor(private utils: UtilService, private spinner: NgxSpinnerService,
    private urlService: UrlService, private globalService: GlobalService, private alertService: AlertService) {
    this.urlFTP = sessionStorage.getItem(ConstantesService.FTP_SESSSION);
    this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);

  }

  ngOnInit() {
    this.listaFuncionarios = [];
  }



  /**
  * Metodo que verifica si el campo filtro se ecuentra con un nombre o tipo de documento
  * para realizar el llamado de la consulta repecto a dicho filtro
  */
  buscarPorFiltro() {
    if ((!this.utils.validarCamposObligatorios(this.filtroNombre)
      && !this.utils.validarCamposObligatorios(this.filtroFecha))
      || (!this.utils.validarCamposObligatorios(this.filtroNombre)
        && this.utils.validarCamposObligatorios(this.filtroFecha))
    ) {
      this.consultarFuncionariosConRegistro();
    } else {
      if (this.validarCaracteresFiltro(this.filtroNombre)) {
        this.consultarFuncionariosConRegistro(this.filtroNombre, null);
      } else {
        this.consultarFuncionariosConRegistro(null, this.filtroNombre);
      }
    }
  }

  /**
   * Peticion de consulta de funcionarios vinculados
   * @param numeroDocumento contiene el numero ingresado en el campo filtro para realizar la consulta
   * @param nombre contiene el nombre ingresado en el campo filtro para realizar la consultar
   */
  consultarFuncionariosConRegistro(numeroDocumento?: string, nombre?: string) {
    this.listaFuncionarios = [];
    this.spinner.show();
    const serviceProvider = 'ConsultaFuncionario';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    if (numeroDocumento) {
      queryParams.push(['numeroDocumento', numeroDocumento]);
    }
    if (nombre) {
      queryParams.push(['nombre', nombre]);
    }

    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
    this.globalService.getGenerico(url)
      .subscribe((dataFuncionario: ConsultaFuncionarioDTO[]) => {
        if (dataFuncionario.length > 0) {
          this.listaFuncionarios = dataFuncionario;
          this.listaFuncionarios.forEach(funcionario => {
            funcionario.urlFoto = this.obtenerUrlFoto(funcionario.urlFotoFuncionario);
          });
        } else if (numeroDocumento || nombre || !isNaN(Date.parse(this.filtroFecha))) {
          this.alertService.generateAlertError('No se encuentran funcionarios con los criterios seleccionados', '');
        }
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.cathException(error.error.message);
      });
  }

  /**
 * Metodo encargado de colocar la foto de la persona o en dicha caso que no tenga
 * coloca la foto por defecto
 */
  public obtenerUrlFoto(url: string): string {
    if (this.urlFTP && this.urlFTP !== '' && url) {
      return this.urlFTP + url;
    } else {
      return 'assets/img/user-male-icon.png';
    }
  }

  /**
 * Método de control de Excepciones
 * @param error mensaje saliente respecto al error ocurrido
 */
  cathException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }



  /**
   * Metodo que valida si filtro ingresado corresponde a un
   * numero de documento o nombre del funcionario
   * @param valor filtro que la persona ingreso
   */
  validarCaracteresFiltro(valor: string): boolean {
    const numeros = '0123456789';
    for (let i = 0; i < valor.length; i++) {
      if (numeros.indexOf(valor.charAt(i), 0) !== -1) {
        return true;
      }
    }

    return false;
  }

}
